import { render } from "./SaveSystemUser.vue?vue&type=template&id=e9d1f03c"
import script from "./SaveSystemUser.vue?vue&type=script&lang=js"
export * from "./SaveSystemUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__